export const optionIncludesValue = (
  options: ReadonlyArray<{ value: string }>,
  value: string
): boolean => options.some(option => option.value === value)
